import React from 'react';
import { IconProps } from '../types';
const MinecraftNameTag: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="10" y="1" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(196, 214, 214, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(224, 239, 239, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(90, 132, 153, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(196, 214, 214, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(90, 132, 153, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(90, 132, 153, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(122, 111, 96, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(173, 188, 188, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(141, 155, 159, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(90, 132, 153, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(90, 132, 153, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="0" y="11" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="0" y="12" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="0" y="13" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(230, 199, 140, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(106, 97, 82, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(122, 113, 98, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(206, 172, 109, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="2" y="15" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="3" y="15" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
<rect x="4" y="15" width="1" height="1" fill="rgba(92, 68, 23, 255)" />
</svg>);
export default MinecraftNameTag;